export default {"src":"/_next/static/media/left_quote.47882ec0.svg","height":92,"width":92,"blurWidth":0,"blurHeight":0};